import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from "axios";
import { useToastStore } from "@/stores/toastStore.js";

export const useCabinetsPageStore = defineStore('cabinets-page-store',  () => {

  const toastStore = useToastStore()

  const cabinetList = ref([])
  const allCabinets = ref([])
  const openNewCabinetPopup = ref(false)

  function getCabinetList() {
    axios.get(`/api/cabinets`).then( r => cabinetList.value = r.data )
  }

  function getAllCabinets() {
    axios.get(`/api/cabinets`, { params: { all: true } }).then(r => {
      allCabinets.value = r.data
    })
  }

  function createCabinet(newCabinetData) {
    axios.post(`/api/cabinets`, newCabinetData).then(r => {
      cabinetList.value = r.data
      toastStore.showToastMessage('New cabinet created', 'success', 'add')
    })
  }

  function setOpenNewCabinetPopup(value) {
    openNewCabinetPopup.value = value
  }

  return {
    cabinetList,
    allCabinets,
    openNewCabinetPopup,
    getCabinetList,
    getAllCabinets,
    createCabinet,
    setOpenNewCabinetPopup
  }
})
